import React from "react";
import Button from "@material-ui/core/Button";

const MainButton = ({ label, color, textColor, icon, width, disabled, type, handleClick }) => {

  return (
    <Button
      variant="contained"
      type={type || "button"} // default เป็น button ถ้าไม่ส่ง type มา
      className={`jr-btn jr-btn-sm ${textColor ? textColor : "text-white"} ${color ? color : "bg-orange"}`}
      startIcon={ icon ? icon : ""}
      style={{ fontWeight: "bold", width: `${ width ? width : "120px" }` }}
      onClick={ type === "submit" ? undefined : handleClick } // ถ้าเป็น submit ไม่ต้องใช้ onClick
      disabled={disabled ? disabled : false}
    >
    { label }
    </Button>
  );
};

export default MainButton;